import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '*', // 防止輸入不存在網址
      redirect: '/home/news' // 導回登入頁
    },
    {
      path: '/',
      redirect: '/home/news'
    },
    {
      path: '/login/*',
      redirect: '/home/news'
    },
    {
      path: '/home',
      redirect: '/home/news'
    },
    {
      path: '/inquire',
      redirect: '/home/news'
    },
    {
      path: '/admin',
      redirect: '/admin/login'
    },
    {
      path: '/admin/project',
      redirect: '/admin/login'
    },
    { // 前台版面
      name: 'Home',
      path: '/home',
      component: () => import('./views/Home.vue'),
      children: [
        { // 首頁
          name: 'Home_News',
          path: 'news',
          component: () => import('./views/News.vue')
        },
        { // 選擇身分
          name: 'Home_identity',
          path: 'identity',
          component: () => import('./views/Login/Registered.vue')
        },
        { // 登入頁
          name: 'Home_Login',
          path: 'login/:identity',
          props: true,
          component: () => import('./views/Login/Signin.vue')
        },
        { // 帳號權限管理主版
          name: 'Account',
          path: 'account',
          meta: { requiresAuth: true },
          component: () => import('./views/User/Account.vue'),
          children: [
            { // 個人資訊頁
              name: 'u_Account_User',
              path: 'user/:uid',
              props: true,
              meta: { requiresAuth: true },
              component: () => import('./views/User/User.vue')
            }
          ]
        },
        { // 教務證件版面
          name: 'Inquire',
          path: '/inquire',
          meta: { requiresAuth: true },
          component: () => import('./views/Inquire/Inquire.vue'),
          children: [
            { // 證件申請
              name: 'u_Document',
              path: 'document',
              meta: { requiresAuth: true },
              component: () => import('./views/Inquire/document.vue')
            },
            { // 費用結算
              name: 'u_Checkout',
              path: 'checkout',
              meta: { requiresAuth: true },
              component: () => import('./views/Inquire/checkout.vue')
            },
            { // 訂單查詢
              name: 'u_Order',
              path: 'order',
              meta: { requiresAuth: true },
              component: () => import('./views/Inquire/order.vue')
            }
          ]
        }
      ]
    },
    { // 後台版面
      name: 'Admin',
      path: '/admin',
      component: () => import('./views/Base.vue'),
      children: [
        { // 登入
          name: 'a_Login',
          path: 'login',
          component: () => import('./views/Login/AdminLogin.vue')
        },
        { // 帳號管理
          name: 'a_Account',
          path: 'account',
          meta: { requiresAuth: true },
          component: () => import('./views/User/Account.vue'),
          children: [
            {
              name: 'a_Manager',
              path: 'manager',
              meta: { requiresAuth: true },
              component: () => import('./views/User/Manager.vue')
            },
            {
              name: 'a_User',
              path: 'user/:id',
              props: true,
              meta: { requiresAuth: true },
              component: () => import('./views/User/AdminUser.vue')
            }
          ]
        },
        { // 訂單查詢
          name: 'a_Order',
          path: 'order',
          meta: { requiresAuth: true },
          component: () => import('./views/Inquire/order.vue')
        },
        { // 列印封面
          name: 'a_FrontCover',
          path: 'frontcover/:uid',
          props: true,
          meta: { requiresAuth: true },
          component: () => import('./views/Inquire/FrontCover.vue')
        },
        { // 繳費項目管理版面
          name: 'a_Project',
          path: 'project',
          meta: { requiresAuth: true },
          component: () => import('./views/Project/Project.vue'),
          children: [
            { // 證件種類
              name: 'a_Document',
              path: 'document',
              meta: { requiresAuth: true },
              component: () => import('./views/Project/document.vue')
            },
            { // 郵資項目
              name: 'a_Postage',
              path: 'postage',
              meta: { requiresAuth: true },
              component: () => import('./views/Project/postage.vue')
            },
            { // 明細報表
              name: 'a_Detail',
              path: 'detail',
              meta: { requiresAuth: true },
              component: () => import('./views/Project/detail.vue')
            },
            { // 結帳報表
              name: 'a_Checkout',
              path: 'checkout',
              meta: { requiresAuth: true },
              component: () => import('./views/Project/checkout.vue')
            }
          ]
        }
      ]
    }
  ],
  /* 切換頁面回到頂端 */
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
